import { render, staticRenderFns } from "./ColonPreviewBowelCleanseForms.vue?vue&type=template&id=79b2cda0&scoped=true&"
import script from "./ColonPreviewBowelCleanseForms.vue?vue&type=script&lang=js&"
export * from "./ColonPreviewBowelCleanseForms.vue?vue&type=script&lang=js&"
import style0 from "./ColonPreviewBowelCleanseForms.vue?vue&type=style&index=0&id=79b2cda0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b2cda0",
  null
  
)

export default component.exports